<h2
  mat-dialog-title
  class="testimonials-modal-title"
>
  {{ name }}
</h2>
<mat-dialog-content>
  <img
    src="/assets/icons/shapes/close.svg"
    alt=""
    class="close-modal"
    (click)="this.dialogRef.close();"
  >
  <p
    class="testimonials-modal-content"
  >
    {{ content }}
  </p>
</mat-dialog-content>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/show-testimonials-content-modal-base/show-testimonials-content-modal-base.component.html